import React from 'react';
import { Stack } from '@domain-group/fe-blueprint-ui/layout';
import { AverageRatingText } from './average-star-rating-text';
import TotalReviewsText from './components/total-reviews-text';
import { StarRating } from './components/star-rating/star-rating';
import * as styles from './average-star-rating-and-total.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AverageStarRatingAndTotal = _ref => {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    _ref$averageRating = _ref.averageRating,
    averageRating = _ref$averageRating === void 0 ? 0 : _ref$averageRating,
    _ref$totalReviews = _ref.totalReviews,
    totalReviews = _ref$totalReviews === void 0 ? 0 : _ref$totalReviews;
  var starGap = 1;
  var starSize = size === 's' || size === 'xs' ? 12 : 16;
  var strokeWidth = 5;
  return ___EmotionJSX(Stack, {
    css: styles.container,
    verticalAlign: "center",
    gap: "xxs",
    id: "star-rating"
  }, ___EmotionJSX(AverageRatingText, {
    size: size,
    value: averageRating
  }), ___EmotionJSX(StarRating, {
    rating: averageRating,
    starGap: starGap,
    starSize: starSize,
    strokeWidth: strokeWidth
  }), totalReviews > 0 && ___EmotionJSX(TotalReviewsText, {
    totalReviews: totalReviews,
    size: size
  }));
};
export { AverageStarRatingAndTotal };